export const mapCreateReport = (favouriteId: number, serializedFormData: any, updateExisting:boolean = false) => {
  return {
    draft: favouriteId,
    description: serializedFormData.title,
    UpdateExistingValidFavourite: updateExisting,
    ...(serializedFormData.owner.hasOwnProperty('v') && {
      owner: serializedFormData.owner.v
    }),
    ...(serializedFormData.users && {
      sharedUsers: serializedFormData.users.map(item => item.value)
    }),
    ...(serializedFormData.user_group && {
      sharedUserGroups: serializedFormData.user_group.map(item => item.value)
    }),
    ...(serializedFormData.folder.hasOwnProperty('v') && {
      folder: serializedFormData.folder.v
    })
  };
};

export const mapUpdateFolder = (serializedFormData: any) => {
  return {
    name: serializedFormData.title,
    ...(serializedFormData.owner.hasOwnProperty('v') && {
      owner: serializedFormData.owner.v
    }),
    ...(serializedFormData.users && {
      sharedUsers: serializedFormData.users.map(item => item.value)
    }),
    ...(serializedFormData.user_group && {
      sharedUserGroups: serializedFormData.user_group.map(item => item.value)
    }),
    ...(serializedFormData.folder.hasOwnProperty('v') && {
      parentFolder: serializedFormData.folder.v
    }),
    updateOwnerForAllDescendants: !!serializedFormData.updateOwnerForAllDescendants,
    updateShareInformationForAllDescendants: !!serializedFormData.updateShareInformationForAllDescendants
  };
};
